import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-assessment-discipline',
  templateUrl: './assessment-discipline.component.html',
  styleUrls: ['./assessment-discipline.component.css']
})
export class AssessmentDisciplineComponent implements OnInit {

  constructor(private examService:ExamService,private lookupService: LookupService, private globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
 
  DisciplineModel = {
    StudentID: 0,
    SessionID: 0,
    ClassID: 0,
    ClassSectionID: "",
    IsSubmitted: false,
    DisciplineID:0,
    SectionID:0,
    TermID:0,

}

StudentList = [];
GetDiscipline  () {
   
    if (this.DisciplineModel.DisciplineID == 0) {
        return;
    }
    this.spinnerService.show();
   
    this.examService.GetDiscipline(JSON.stringify(this.DisciplineModel)).subscribe( (data)=> {
        this.StudentList = data.StudentList;
        
        this.spinnerService.hide();
    });
}




SaveDiscipline  () {
    if (this.DisciplineModel.DisciplineID == 0) {
        return;
    }
    

    this.examService.SaveDiscipline(JSON.stringify(this.DisciplineModel), JSON.stringify(this.StudentList)).subscribe( (response)=> {
        

        this.globalHelper.CheckActionStatus(response);
        this.GetDiscipline();

    });

}



SubmitDiscipline  () {
    if (this.DisciplineModel.DisciplineID == 0) {
        return;
    }
    this.DisciplineModel.IsSubmitted = true;
    var r = confirm("are you sure you want to submit you will not able to edit");
    if (r == false) {
        return false
    }
    

    this.examService.SaveDiscipline(JSON.stringify(this.DisciplineModel), JSON.stringify(this.StudentList)).subscribe( (response)=> {
       

        this.globalHelper.CheckActionStatus(response);
        this.GetDiscipline();

    });

}


ClassSectionList:any;
GetClassSection  () {
    this.lookupService.GetLookupsList('CTClassSection', '').subscribe( (data)=> {
        this.ClassSectionList = data.LookupItems;

    });

};


SetID  () {
    this.StudentList = [];
    this.TermList = []
    this.DisciplineModel.ClassID = 0;
    this.DisciplineModel.SectionID = 0;
    if (this.DisciplineModel.ClassSectionID != "" ) {
        var strClassSectionID = this.DisciplineModel.ClassSectionID.split('-');
        this.DisciplineModel.ClassID = parseInt(strClassSectionID[0]);
        this.DisciplineModel.SectionID = parseInt(strClassSectionID[1]);
        this.DisciplineModel.TermID = 0;
        this.DisciplineModel.DisciplineID = 0;               
        this.GetTerm();
    }



}

TermList:any;
DisciplineMappingList =[];
GetTerm  () {
    this.StudentList = [];
    this.DisciplineModel.TermID = 0;
    this.TermList = {}
    this.DisciplineModel.DisciplineID = 0;
    this.DisciplineMappingList =[];
    this.spinnerService.show();
    var ItemBo = {
        ItemId: this.DisciplineModel.ClassID
    }
    this.lookupService.GetLookupsList('ExamTerm', JSON.stringify(ItemBo)).subscribe( (data)=> {
        this.TermList = data.LookupItems;
        this.spinnerService.hide();
    });
};


GetDisciplineMapping  () {
    this.StudentList = [];
    this.DisciplineModel.DisciplineID = 0;
    this.spinnerService.show();
    var ItemBo = {
        ItemId: this.DisciplineModel.ClassID,
        ItemId1: this.DisciplineModel.TermID
    }
    this.lookupService.GetLookupsList('Discipline', JSON.stringify(ItemBo)).subscribe( (data)=> {
        this.DisciplineMappingList = data.LookupItems;
        this.spinnerService.hide();
    });
};
  ngOnInit() {
    this.GetClassSection();
  }

}
